let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6CBhM"), load("dXF2m"), load("2sCab")]).then(() => parcelRequire('3GuAz'));